'use client';

import { useLocale } from 'next-intl';
import { useCallback } from 'react';

import { apiFetch } from './apiFetch';

/**
 * `fetch` vers `/api/**` qui transmet explicitement la locale de la page.
 *
 * Les routes API vivent hors du segment `[locale]` : elles n'ont donc pas de
 * `requestLocale` et retomberaient sur le cookie `NEXT_LOCALE`. Or le cookie est
 * global au navigateur : deux onglets ouverts dans deux langues se marchent
 * dessus, et le dernier qui change de langue décide du contenu servi aux deux.
 * Le header rend la locale déterministe par requête.
 *
 * À utiliser pour toute lecture/écriture d'API locale-dépendante. Les surfaces
 * indépendantes de la langue (`/api/auth/logout`, `/api/locales`) n'en ont pas
 * besoin.
 */
export function useApiFetch(): typeof fetch {
    const locale = useLocale();
    return useCallback(
        (input: Parameters<typeof fetch>[0], init?: Parameters<typeof fetch>[1]) =>
            apiFetch(input, init, locale),
        [locale],
    );
}
